import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ReactCountryFlag from "react-country-flag"  ;
import ReactFlagsSelect from "react-flags-select" ;
import CPays from './app/composant/CPays'
import Footer from './app/composant/Footer'
import Toptitre from './app/composant/Toptitre';
import CAcceuil from './app/composant/CAcceuil';


function App() {
   const paysIni = useSelector(state => state.ComPays)    
      const regionIni = useSelector(state => state.ComRegion)
      const dispatch = useDispatch()
      const [select, setSelect] = useState("");
      const onSelect = (code) => setSelect(code);
      const[showpays, setShowpays]= useState(false)

  return ( 
    <div >   
        <div className='row '>
            <div className='container-fluid topbg skicky-top'>
              <Toptitre/>
             
            </div>
          </div>

        <div className='row'> 
            <div className='container-fluid mx-auto milieu '>
                <CAcceuil></CAcceuil>                  
            </div>     
               
        </div> 
        <div className='row'>
            < div className='jumbotron-fluid'>       
                <Footer/> 
            </div>
        </div> 
  </div>    
  );
}

export default App;
